<template>
  <section>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="step-form__main">
          <el-row :gutter="0">
            <el-col :span="16">
              <el-form class="step-form__form" :model="brokerSubmitForm" ref="brokerSubmitForm" :rules="rules">
                <el-row>
                  <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom:30px;">Business Information</h3>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="businessName" required>
                      <el-input type="text" placeholder="Company legal name *" v-model="brokerSubmitForm.businessName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="tradeName">
                      <el-input type="text" placeholder="DBA (If applicable)" v-model="brokerSubmitForm.tradeName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item prop="businessStreetAddress" required>
                  <el-input type="text" placeholder="Address *" :maxlength="40" v-model="brokerSubmitForm.businessStreetAddress"></el-input>
                </el-form-item>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="businessCityName" required>
                      <el-input type="text" placeholder="City *" :maxlength="30" v-model="brokerSubmitForm.businessCityName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="businessState"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.businessState" placeholder="Select state *">
                        <el-option
                          v-for="item in stateS"
                          :key="item.text"
                          :label="item.text"
                          :value="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="zip" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="Zip *"
                        :maxlength="5"
                        v-model="brokerSubmitForm.zip"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="phone" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="Company phone *"
                        :maxlength="10"
                        v-model="brokerSubmitForm.phone"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="companyEmail" required>
                      <el-input
                        type="text"
                        placeholder="Company email *"
                        :maxlength="30"
                        v-model="brokerSubmitForm.companyEmail"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item>
                      <el-input type="text" v-model="brokerSubmitForm.url" placeholder="Website"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="stateOfInc"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.stateOfInc" placeholder="Select state of incorporation *">
                        <el-option
                          v-for="item in stateS"
                          :key="item.text"
                          :label="item.text"
                          :value="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="dateEstablished" required>
                      <el-date-picker
                        v-model="brokerSubmitForm.dateEstablished"
                        placeholder="Date established *"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions1"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item style="width: 100%;" prop="tin" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="EIN (Tax ID number) *"
                        :maxlength="10"
                        v-model="brokerSubmitForm.tin"
                        @input="handleTinInput"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="industry"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.industry" placeholder="Select industry type *">
                        <el-option
                          v-for="item in industries"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="structure"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.structure" placeholder="Company structure *">
                        <el-option
                          v-for="item in structures"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="revenue" required>
                      <el-input
                        type="number"
                        v-model="brokerSubmitForm.revenue"
                        placeholder="Annual revenue *"
                        :maxlength="16"
                      >
                        <template slot="prepend">$</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="Business description" class="margin-bottom-0" prop="description" required>
                  <el-input type="textarea" placeholder="Please include details by describing your business, revenue stream, and specifics to the need for this loan. For Equipment Financing, please also add how this equipment loan will increase your revenue (i.e. debt service coverage ratio before and after loan) and what is the timing you will start to see a contribution to your revenue?" v-model="brokerSubmitForm.description" :rows=3></el-input>
                </el-form-item>

                <el-row>
                  <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom:30px;">Business Owners</h3>
                </el-row>
                <el-row :gutter="20">
                  <!--First Name-->
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item prop="firstName" required>
                      <el-input type="text" placeholder="First name *" :maxlength="30" v-model="brokerSubmitForm.firstName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="4" :lg="4">
                    <el-form-item>
                      <el-input type="text" placeholder="Middle name" :maxlength="30" v-model="brokerSubmitForm.middleName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item prop="lastName" required>
                      <el-input type="text" placeholder="Last name *" :maxlength="30" v-model="brokerSubmitForm.lastName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="ssn">
                      <el-input
                        type="text"
                        placeholder="Social security number"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        v-model="brokerSubmitForm.ssn"
                        :maxlength="9"
                      ></el-input>
                      <!-- We use 256-bit SSL protection and strict, high levels of security
                      <br />and encryption standards to keep
                      your information safe. -->
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="streetAddress" required>
                      <el-input
                        type="text"
                        placeholder="Home address *"
                        :maxlength="40"
                        v-model="brokerSubmitForm.streetAddress"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="4" :lg="4">
                    <el-form-item prop="cityName" required>
                      <el-input type="text" placeholder="City name *" :maxlength="30" v-model="brokerSubmitForm.cityName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="4" :lg="4">
                    <el-form-item prop="state" class="step-form__form-item--with-unit" required>
                      <el-select v-model="brokerSubmitForm.state" placeholder="Select state *">
                        <el-option
                          v-for="item in stateS"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="4" :lg="4">
                    <el-form-item prop="zipCode" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="Zip code *"
                        :maxlength="5"
                        v-model="brokerSubmitForm.zipCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="dateOfBirth" required>
                      <el-date-picker
                        v-model="brokerSubmitForm.dateOfBirth"
                        placeholder="Date of birth *"
                        type="date"
                        @change="getData"
                        :picker-options="pickerOptions1"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="cellPhone" required>
                      <el-input
                        type="tel"
                        placeholder="Phone *"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        v-model="brokerSubmitForm.cellPhone"
                        :maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="email" required>
                      <el-input
                        type="text"
                        placeholder="Email *"
                        v-model="brokerSubmitForm.email"
                        :maxlength="30"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="jobTitle">
                      <el-input
                        type="text"
                        placeholder="Title (if applicable)"
                        v-model="brokerSubmitForm.jobTitle"
                        :maxlength="30"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="businessOwnership" required>
                      <el-input
                        type="number"
                        v-model="brokerSubmitForm.businessOwnership"
                        placeholder="Business ownership % *"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        :min="0"
                        :max="100"
                      >
                        <template slot="append">%</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom:30px;" v-on:click="showAddOwner = !showAddOwner">Add owner<i style="float: right; margin-right: 10px;" class="fa" :class="{'fa-chevron-up': showAddOwner, 'fa-chevron-down': !showAddOwner }" aria-hidden="true"></i></h3>
                </el-row>

                <div v-show="showAddOwner">
                  <el-row :gutter="20">
                    <!--First Name-->
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item prop="firstName2">
                        <el-input type="text" placeholder="First name" :maxlength="30" v-model="brokerSubmitForm.firstName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="4" :lg="4">
                      <el-form-item>
                        <el-input type="text" placeholder="Middle name" :maxlength="30" v-model="brokerSubmitForm.middleName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item prop="lastName2">
                        <el-input type="text" placeholder="Last name" :maxlength="30" v-model="brokerSubmitForm.lastName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item prop="ssn2">
                        <el-input
                          type="text"
                          placeholder="Social security number"
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          v-model="brokerSubmitForm.ssn2"
                          :maxlength="9"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item prop="streetAddress2">
                        <el-input
                          type="text"
                          placeholder="Home address"
                          :maxlength="40"
                          v-model="brokerSubmitForm.streetAddress2"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item prop="cityName2">
                        <el-input type="text" placeholder="City name" :maxlength="30" v-model="brokerSubmitForm.cityName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item prop="state2" class="step-form__form-item--with-unit">
                        <el-select v-model="brokerSubmitForm.state2" placeholder="Select state">
                          <el-option
                            v-for="item in stateS"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item prop="zipCode2">
                        <el-input
                          type="tel"
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          placeholder="Zip code"
                          :maxlength="5"
                          v-model="brokerSubmitForm.zipCode2"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item prop="cellPhone2">
                        <el-input
                          type="tel"
                          placeholder="Phone"
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          v-model="brokerSubmitForm.cellPhone2"
                          :maxlength="10"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item prop="email2">
                        <el-input
                          type="text"
                          placeholder="Email"
                          v-model="brokerSubmitForm.email2"
                          :maxlength="30"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item prop="jobTitle2">
                        <el-input
                          type="text"
                          placeholder="Title (if applicable)"
                          v-model="brokerSubmitForm.jobTitle2"
                          :maxlength="30"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item prop="businessOwnership2">
                        <el-input
                          type="number"
                          v-model="brokerSubmitForm.businessOwnership2"
                          placeholder="Business ownership %"
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :min="0"
                          :max="100 - brokerSubmitForm.businessOwnership"
                        >
                          <template slot="append">%</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>

                <el-row>
                  <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom:30px;">Vendor (if applicable)</h3>
                </el-row>              
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="vendorName">
                      <el-input type="text" placeholder="Vendor name" v-model="brokerSubmitForm.vendorName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="vendorPhone">
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="Company phone"
                        :maxlength="10"
                        v-model="brokerSubmitForm.vendorPhone"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item prop="vendorAddress">
                  <el-input type="text" :maxlength="40" v-model="brokerSubmitForm.vendorAddress" placeholder="Vendor address"></el-input>
                </el-form-item>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="vendorCity" required>
                      <el-input type="text" :maxlength="30" v-model="brokerSubmitForm.vendorCity" placeholder="City *"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="vendorState"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.vendorState" placeholder="Select state *">
                        <el-option
                          v-for="item in stateS"
                          :key="item.text"
                          :label="item.text"
                          :value="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="vendorZipCode" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="Zip code *"
                        :maxlength="5"
                        v-model="brokerSubmitForm.vendorZipCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="Contact first name">
                      <el-input type="text" placeholder="Contact first name" :maxlength="30" v-model="brokerSubmitForm.vendorContactFirstName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="Contact last name">
                      <el-input type="text" placeholder="Contact last name" :maxlength="30" v-model="brokerSubmitForm.vendorContactLastName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="Contact email">
                      <el-input
                        type="text"
                        placeholder="Contact email"
                        :maxlength="30"
                        v-model="brokerSubmitForm.vendorContactEmail"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="Equipment amount" prop="equipmentAmount" required>
                      <el-input
                        type="number"
                        v-model="brokerSubmitForm.equipmentAmount"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        :maxlength="8"
                        :min="0"
                      >
                        <template slot="prepend">$</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      label="Equipment status"
                      prop="equipmentStatus"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.equipmentStatus">
                        <el-option
                          v-for="item in status"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      label="Titled or Non-titled"
                      prop="equipmentTitle"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.equipmentTitle">
                        <el-option
                          v-for="item in titled"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="amount" required>
                      <el-input type="number" onkeypress="return event.keyCode>=48&&event.keyCode<=57" v-model="brokerSubmitForm.amount" placeholder="Loan amount *">
                        <template slot="prepend">$</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="term" required>
                      <el-select v-model="brokerSubmitForm.term" placeholder="Desired loan term *" class="select_width">
                        <el-option
                          v-for="item in equipmentLoanTermS"
                          :key="item.value"
                          :label="item.text.concat(' months')"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="equipmentType"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.equipmentType" placeholder="Equipment Type *">
                        <el-option
                          v-for="item in equipmentTypes"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="Equipment description" class="margin-bottom-0" prop="equipmentDesc" required>
                  <el-input type="textarea" v-model="brokerSubmitForm.equipmentDesc" :rows=3></el-input>
                </el-form-item>

                <!-- <div v-if="frontApplyId != ''"> -->
                  <el-row>
                      <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom:30px;">Documents</h3>
                  </el-row>
                  <el-row>
                      <h3 style="color: #E06D21; font-family: 'Open Sans', sans-serif; font-weight: 700; font-size: 14px; line-height: 24px; text-align:left;">Upload your business related documents. Must be PDF, JPEG, PNG or Excel. Individual files must be under 20 MB.</h3>
                  </el-row>
                  <div v-if="!dialogVisible" style="height: auto; float: left;">
                    <el-upload
                      ref="upload"
                      class="avatar-uploader"
                      action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                      :data="{tokenId: this.userInfo.token, customerId: this.clientCustomerId}"
                      accept="*.*"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                      :on-progress="openFullScreen"
                      :auto-upload="false"
                      :on-change="submitUpload"
                    >
                      <!-- <el-button slot="trigger" size="small" type="primary">Selection</el-button>
                      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">upload</el-button> -->
                      <button type="button">
                        <i class="el-icon-plus">
                          <span style="margin-left: 10px;">Add Attachment</span>
                        </i>
                      </button>
                    </el-upload>
                  </div>
                  <div id="uploaded" class="step-form__title">
                    <a :href="fileUrl1" target="_blank" class="link preview_old">{{fileName1}}</a>
                  </div>

                  <el-dialog v-model="dialogVisible" size="tiny">
                    <img width="100%" :src="dialogImageUrl" alt />
                  </el-dialog>

                  <el-table :data="uploadedDocuments" align="left">
                    <el-table-column type='index' label="#" >
                      <template slot-scope="scope">
                        <span>{{scope.$index + 1}}</span>
                      </template>
                    </el-table-column>

                    <el-table-column prop="fileName" label="File Name"></el-table-column>

                    <el-table-column prop="ext" label="File Type"></el-table-column>

                    <el-table-column label="Actions">
                      <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="reviewFile(scope.row.fileId)">Review</el-button>
                        <el-button size="mini" type="danger" @click="deleteFile(scope.row.fileId)">Delete</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                <!-- </div> -->

                <el-form-item class="margin-bottom-0" style="margin-top: 25px;">
                  <el-input type="textarea" placeholder="Notes" v-model="brokerSubmitForm.brokerNote" :rows=3></el-input>
                </el-form-item>

              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
          <div class="step-form__main pt-3">
            <el-row :gutter="0">
              <el-col :span="16">
                <el-form class="step-form__form">

                  <el-row>
                      <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom: 20px;">Declaration</h3>
                  </el-row>

                  <p style="color: #33475b; font-family: 'Open Sans', sans-serif;font-weight: 400;font-size: 14px;line-height: 24px; text-align: left;">
                  I hereby confirm that each Company Owner of the Company provided in this Application (i) is aware of the Company's request for financing; (ii) may be required to guaranty the requested financing; and (iii) have authorized American Credit, Inc and any assignee, lender, or funding service that may be used to obtain their respective business and consumer credit report and have authorized me to provide their consent (collectively theCredit Consent).
                  </p>

                  <p style="color: #33475b; font-family: 'Open Sans', sans-serif;font-weight: 400;font-size: 14px;line-height: 24px; text-align: left;">
                  By clicking I agree below, I am authorized to, and hereby permit, American Credit, Inc and any assignee, lender, or funding service that may be used to obtain (i) a consumer credit report on each Company Owner for credit purposes & further authorize the release to American Credit, Inc and any assignee, lender, or funding service that may be used of all credit information it may request, including business & personal banking, mortgage, landlord, trade & lease information related to each of them; and (ii) confirm that each Company Owner of the company has provided the Credit Consent.
                  </p>
                  
                  <div style="text-align: left; margin-left: 5px;">
                    <el-radio-group v-model="declarationAgree" style="text-align: left;">
                      <el-row :gutter="10">
                        <el-radio label="agree">I agree</el-radio>
                      </el-row>
                      <el-row :gutter="10">>
                        <el-radio label="disagree">I disagree</el-radio>
                      </el-row>
                    </el-radio-group>
                  </div>
                  <p style="color: #33475b; font-family: 'Open Sans', sans-serif;font-weight: 400;font-size: 14px;line-height: 24px; text-align: left;">I hereby confirm that by providing American Credit, Inc and any assignee, lender, or funding service that may be used with an email address or telephone number, including for a wireless device, I have obtained, and am authorized to provide, the necessary express consent from each Company Owner, and that by submitting this Application, I expressly consent on behalfof each Company Owner to communications including email, voice and text messages from, or on behalf of, American Credit, Inc and any assignee, lender, or funding service that may be used, regardless of their purpose, including but not limited to marketing or collection purposes. I understand and agree that: (i) these calls and messages may be subject to charges from an internet or wireless provider; (ii) this consent is not a condition of doing business with, or making a purchase of any goods/services from, American Credit, Inc and any assignee, lender, or funding service that may be used;and (iii) any Company Owner may unsubscribe or opt-out of any further telemarketing calls or marketing text messages at any time.</p>

                  <p style="color: #33475b; font-family: 'Open Sans', sans-serif;font-weight: 400;font-size: 14px;line-height: 24px; text-align: left;">By clicking submit, you hereby agree the information you provided as well asthe confirmations set forth in this Application are true and accurate.</p>

                  <p style="color: #33475b; font-family: 'Open Sans', sans-serif;font-weight: 400;font-size: 14px;line-height: 24px; text-align: left;">Thank you for your business credit application. We will review it carefully andget back to you promptly.</p>

                </el-form>
              </el-col>
            </el-row>

            <div class="step-form__btn-container" v-if="frontApplyId == ''">
              <el-button
                :disabled="declarationAgree !== 'agree'"
                type="primary"
                :loading="isLoading"
                class="rounded-pill blue px-5"
                style="float: center;"
                @click="submitApplicationForm"
              >Submit</el-button>
            </div>
            <div class="step-form__btn-container" v-if="frontApplyId != ''">
              <el-button
                :disabled="declarationAgree !== 'agree'"
                type="primary"
                :loading="isLoading"
                class="rounded-pill blue px-5"
                style="float: center;"
                @click="submitApplicationForm"
              >Save</el-button>
            </div>
          <br />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Loading } from "element-ui";
import * as types from "../../vuex/types";
import _ from "lodash";
import api from "../../vuex/api/index";

// ä¼�ä¸šé‚£è¾¹å¦‚æžœç•Œé�¢å·®å¼‚å�˜å¤§ï¼Œåˆ™å»ºè®®åˆ†å‡ºåŽ»å�¦ä¸€ä¸ªç»„ä»¶
export default {
  data() {
    const assignValidator = (type, trigger = "blur") =>
      Object.assign(
        {
          //        required: true,
          trigger
        },
        {
          validator: (rules, value, callback, source, options) => {
            this.$store.dispatch(type, {
              rules,
              value,
              callback,
              source,
              options
            });
          }
        }
      );
    return {
      pickerOptions1: {
        disabledDate(time) {
          let curDate = (new Date()).getTime();
          let I8Years = (365 * 18 + 5) * 24 * 3600 * 1000;
          let I00Years = (365 * 100 + 26) * 24 * 3600 * 1000;
          let I8YearsDate = curDate - I8Years;
          let I00YearsDate = curDate - I00Years;
          // return time.getTime() > I8YearsDate || time.getTime() < I00YearsDate;
          return time.getTime() < I00YearsDate;
        }
      },
      isLoading: false,
      isLoadingCode: false,
      isSubmitting: false,
      isEditable: "",
      screenHeight: document.body.clientHeight,
      isApplyFirst: true,
      frontApplyId: this.$route.params.frontApplyId || "",
      firstTimeUploadFileIndicator: 0, // 0 initial status, 1 start to submit basic info, 2 start to upload file, -1 file uploaded
      clientCustomerId: "",
      clientEmployerId: "",
      uploadedDocuments: [],
      industries: [
        {
          value: "Agriculture (Veterinarian, Farming, etc.)",
          text: "Agriculture (Veterinarian, Farming, etc.)"
        },
        {
          value: "Construction (Building Construction, Contractors, etc.)",
          text: "Construction (Building Construction, Contractors, etc.)"
        },
        {
          value: "Finance, Insurance, or Real Estate",
          text: "Finance, Insurance, or Real Estate"
        },
        { value: "Health Services", text: "Health Services" },
        {
          value: "Manufacturing",
          text: "Manufacturing"
        },
        {
          value: "Restaurants Bars Catering",
          text: "Restaurants Bars Catering"
        },
        {
          value: "Retail",
          text: "Retail"
        },
        {
          value: "Services (Personal, Business, Legal, etc.)",
          text: "Services (Personal, Business, Legal, etc.)"
        },
        {
          value: "Transportation",
          text: "Transportation"
        },
        {
          value: "Wholesale Trade",
          text: "Wholesale Trade"
        },
        {
          value: "Other",
          text: "Other"
        }
      ],
      structures: [
        {
          value: "Sole Proprietorship",
          text: "Sole Proprietorship"
        },
        {
          value: "General Partnership",
          text: "General Partnership"
        },
        {
          value: "LLC",
          text: "LLC"
        },
        {
          value: "Single LLC",
          text: "Single LLC"
        },
        {
          value: "Corporation",
          text: "Corporation"
        },
        {
          value: "Professional Corporation",
          text: "Professional Corporation"
        }
      ],
      equipmentLoanTermS: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "18", text: "18" },
        { value: "24", text: "24" },
        { value: "30", text: "30" },
        { value: "36", text: "36" },
        { value: "42", text: "42" },
        { value: "48", text: "48" },
        { value: "54", text: "54" },
        { value: "60", text: "60" },
        { value: "66", text: "66" },
        { value: "72", text: "72" }
      ],
      equipmentTypes: [
        { value: "AIR COMPRESSOR", text: "AIR COMPRESSOR" },
        { value: "APU (Auxiliary Power Units)", text: "APU (Auxiliary Power Units)" },
        { value: "AQUA MASSAGE", text: "AQUA MASSAGE" },
        { value: "ART", text: "ART" },
        { value: "ATM MACHINES (NON-ROUTE)", text: "ATM MACHINES (NON-ROUTE)" },
        { value: "AUDIO/VIDEO EQUIPMENT", text: "AUDIO/VIDEO EQUIPMENT" },
        { value: "AUTO - EMISSIONS / SMOG TESTING", text: "AUTO - EMISSIONS / SMOG TESTING" },
        { value: "AUTO - SPRAY BOOTHS", text: "AUTO - SPRAY BOOTHS" },
        { value: "AUTO REPAIR EQUIPMENT", text: "AUTO REPAIR EQUIPMENT" },
        { value: "BEAUTY SALON EQUIP", text: "BEAUTY SALON EQUIP" },
        { value: "BEVERAGE MFG EQUIP", text: "BEVERAGE MFG EQUIP" },
        { value: "BODY COMPOSITION", text: "BODY COMPOSITION" },
        { value: "CAR WASH EQUIPMENT", text: "CAR WASH EQUIPMENT" },
        { value: "CARPET CLEANING", text: "CARPET CLEANING" },
        { value: "CHILDCARE EQUIPMENT", text: "CHILDCARE EQUIPMENT" },
        { value: "CLEANING EQUIPMENT", text: "CLEANING EQUIPMENT" },
        { value: "COMMUNICATION / RADIO / TV", text: "COMMUNICATION / RADIO / TV" },
        { value: "COMPUTER EQUIPMENT", text: "COMPUTER EQUIPMENT" },
        { value: "CONCESSION TRUCK/TRAILER", text: "CONCESSION TRUCK/TRAILER" },
        { value: "CONCRETE EQUIPMENT", text: "CONCRETE EQUIPMENT" },
        { value: "CONSTRUCTION EQUIP", text: "CONSTRUCTION EQUIP" },
        { value: "CONTAINER / COMMERCIAL / ROLL-OFF", text: "CONTAINER / COMMERCIAL / ROLL-OFF" },
        { value: "CONTAINERS / RESIDENTAL / WASTE", text: "CONTAINERS / RESIDENTAL / WASTE" },
        { value: "DENTAL EQUIPMENT", text: "DENTAL EQUIPMENT" },
        { value: "DENTAL SUNDRIES", text: "DENTAL SUNDRIES" },
        { value: "DISPLAY / SHOW CASES", text: "DISPLAY / SHOW CASES" },
        { value: "DRY CLEANING EQUIP", text: "DRY CLEANING EQUIP" },
        { value: "ELECTRICAL EQUIPMENT", text: "ELECTRICAL EQUIPMENT" },
        { value: "EMBROIDERY / SEWING EQUIP", text: "EMBROIDERY / SEWING EQUIP" },
        { value: "ENERGY EQUIPMENT", text: "ENERGY EQUIPMENT" },
        { value: "ENGRAVING EQUIPMENT ", text: "ENGRAVING EQUIPMENT " },
        { value: "ENVIRONMENTAL EQUIPMENT", text: "ENVIRONMENTAL EQUIPMENT" },
        { value: "FIRE SUPRESSION", text: "FIRE SUPRESSION" },
        { value: "FITNESS EQUIP / MATS", text: "FITNESS EQUIP / MATS" },
        { value: "FOOD MFG EQUIP", text: "FOOD MFG EQUIP" },
        { value: "FORKLIFTS", text: "FORKLIFTS" },
        { value: "FURNITURE ", text: "FURNITURE " },
        { value: "FURNITURE &amp; FIXTURES", text: "FURNITURE &amp; FIXTURES" },
        { value: "GAS PUMPS / PETROLEUM", text: "GAS PUMPS / PETROLEUM" },
        { value: "GENERATORS (NOT APU)", text: "GENERATORS (NOT APU)" },
        { value: "GYMNASTICS EQUIPMENT", text: "GYMNASTICS EQUIPMENT" },
        { value: "HAND HELD SCANNERS/DASH CAMS", text: "HAND HELD SCANNERS/DASH CAMS" },
        { value: "HVAC / HEATING / COOLING EQUIP", text: "HVAC / HEATING / COOLING EQUIP" },
        { value: "INFLATABLES", text: "INFLATABLES" },
        { value: "LANDSCAPE / HORICULTURE", text: "LANDSCAPE / HORICULTURE" },
        { value: "LIGHTING - INSIDE/OUTSIDE", text: "LIGHTING - INSIDE/OUTSIDE" },
        { value: "MANUFACTURE / MACHINE TOOLS", text: "MANUFACTURE / MACHINE TOOLS" },
        { value: "MANUFACTURING - OTHER EQUIP.", text: "MANUFACTURING - OTHER EQUIP." },
        { value: "MEDICAL EQUIP", text: "MEDICAL EQUIP" },
        { value: "MEDICAL LASER", text: "MEDICAL LASER" },
        { value: "MEDICAL TESTING EQUIPMENT", text: "MEDICAL TESTING EQUIPMENT" },
        { value: "MISC-SLB/REFUNDABLE DEPOSIT", text: "MISC-SLB/REFUNDABLE DEPOSIT" },
        { value: "MUSICAL INSTRUMENTS", text: "MUSICAL INSTRUMENTS" },
        { value: "OFFICE EQUIPMENT", text: "OFFICE EQUIPMENT" },
        { value: "OTHER - PLEASE DESCRIBE", text: "OTHER - PLEASE DESCRIBE" },
        { value: "PHONE SYSTEMS", text: "PHONE SYSTEMS" },
        { value: "PHOTOGRAPHY EQUIPMENT", text: "PHOTOGRAPHY EQUIPMENT" },
        { value: "PLAYGROUND EQUIPMENT", text: "PLAYGROUND EQUIPMENT" },
        { value: "PORTABLE TOILETS", text: "PORTABLE TOILETS" },
        { value: "POS (Point of Sale) System", text: "POS (Point of Sale) System" },
        { value: "POWER WASHERS", text: "POWER WASHERS" },
        { value: "PRINTING EQUIP", text: "PRINTING EQUIP" },
        { value: "RECREATION / SPORTS EQUIPMENT", text: "RECREATION / SPORTS EQUIPMENT" },
        { value: "REEFER UNITS (TITLED)", text: "REEFER UNITS (TITLED)" },
        { value: "REFRIGERATION - WALK-IN/STRUC.", text: "REFRIGERATION - WALK-IN/STRUC." },
        { value: "RESTAURANT / BAR EQUIP", text: "RESTAURANT / BAR EQUIP" },
        { value: "SCREEN PRINT EQUIP", text: "SCREEN PRINT EQUIP" },
        { value: "SECURITY SYS / CAMERAS", text: "SECURITY SYS / CAMERAS" },
        { value: "SIGNAGE", text: "SIGNAGE" },
        { value: "SOFTWARE -  BUILT IN W/ EQUIP", text: "SOFTWARE -  BUILT IN W/ EQUIP" },
        { value: "SOFTWARE - OFF SHELF", text: "SOFTWARE - OFF SHELF" },
        { value: "STORAGE UNIT / PALLETS", text: "STORAGE UNIT / PALLETS" },
        { value: "TANNING BED/SPRAY", text: "TANNING BED/SPRAY" },
        { value: "TITLED - BRUSH-CHIPPER", text: "TITLED - BRUSH-CHIPPER" },
        { value: "TITLED - TRAILER BUILD OUT", text: "TITLED - TRAILER BUILD OUT" },
        { value: "TITLED - TRAILER LIGHT-DUTY", text: "TITLED - TRAILER LIGHT-DUTY" },
        { value: "TRAILERS (NON-TITLED)", text: "TRAILERS (NON-TITLED)" },
        { value: "TRAILERS HEAVY-DUTY (AUTO HAULER)", text: "TRAILERS HEAVY-DUTY (AUTO HAULER)" },
        { value: "TRAILERS HEAVY-DUTY (DRY VAN/REEFER)", text: "TRAILERS HEAVY-DUTY (DRY VAN/REEFER)" },
        { value: "TRAILERS HEAVY-DUTY (FLATBED)", text: "TRAILERS HEAVY-DUTY (FLATBED)" },
        { value: "TRAILERS HEAVY-DUTY (VOCATIONAL)", text: "TRAILERS HEAVY-DUTY (VOCATIONAL)" },
        { value: "TRUCKS / CLASS 1 (GVW <6,000 lbs)", text: "TRUCKS / CLASS 1 (GVW <6,000 lbs)" },
        { value: "TRUCKS / CLASS 2 (GVW 6,001- 10,000 lbs)", text: "TRUCKS / CLASS 2 (GVW 6,001- 10,000 lbs)" },
        { value: "TRUCKS / CLASS 3 (GVW 10,001- 14,000 lbs)", text: "TRUCKS / CLASS 3 (GVW 10,001- 14,000 lbs)" },
        { value: "TRUCKS / CLASS 4 (GVW 14,001- 16,000 lbs)", text: "TRUCKS / CLASS 4 (GVW 14,001- 16,000 lbs)" },
        { value: "TRUCKS / CLASS 5 (GVW 16,001- 19,500 lbs)", text: "TRUCKS / CLASS 5 (GVW 16,001- 19,500 lbs)" },
        { value: "TRUCKS / CLASS 6 (GVW 19,501- 26,000 lbs)", text: "TRUCKS / CLASS 6 (GVW 19,501- 26,000 lbs)" },
        { value: "TRUCKS / CLASS 7 (GVW 26,001- 33,000 lbs)", text: "TRUCKS / CLASS 7 (GVW 26,001- 33,000 lbs)" },
        { value: "TRUCKS / CLASS 8/ DAY CAB (GVW > 33,000 lbs)", text: "TRUCKS / CLASS 8/ DAY CAB (GVW > 33,000 lbs)" },
        { value: "TRUCKS / CLASS 8/ SLEEPER/ REG (GVW > 33,000 lbs)", text: "TRUCKS / CLASS 8/ SLEEPER/ REG (GVW > 33,000 lbs)" },
        { value: "TRUCKS / CLASS 8/ SLEEPER/ VOC (GVW > 33,000 lbs)", text: "TRUCKS / CLASS 8/ SLEEPER/ VOC (GVW > 33,000 lbs)" },
        { value: "VEHICLE WRAPS", text: "VEHICLE WRAPS" },
        { value: "VETERINARIAN EQUIPMENT", text: "VETERINARIAN EQUIPMENT" },
        { value: "WASHER / DRYER / LAUNDRY", text: "WASHER / DRYER / LAUNDRY" },
        { value: "WATER COOLER", text: "WATER COOLER" },
        { value: "WATER TREATMENT", text: "WATER TREATMENT" },
        { value: "WELDING / METAL WORKING", text: "WELDING / METAL WORKING" },
        { value: "WOODWORKING EQUIPMENT", text: "WOODWORKING EQUIPMENT" },
        { value: "WORKING CAPITAL LOAN", text: "WORKING CAPITAL LOAN" }
      ],
      stateS: [],
      titleData: [],
      mastateS: [],
      status: [
        {
          value: "New",
          text: "New"
        },
        {
          value: "Used",
          text: "Used"
        }
      ],
      titled: [
        {
          value: "Titled",
          text: "Titled"
        },
        {
          value: "Non-titled",
          text: "Non-titled"
        }
      ],
      showAddOwner: false,
      isEditable: 0,
      dateOfBirthStr: "",
      dateOfBirth2Str: "",
      dialogImageUrl: "",
      dialogImageUrl2: "",
      fileUrl1:"",
      fileUrl2:"",
      fileName1:"",
      fileName2:"",
      dialogVisible: false,
      dialogVisible2: false,
      declarationAgree: "",
      brokerSubmitForm: {
        businessName: "",
        tradeName: "",
        fax: "",
        description: "",
        industry: "",
        structure: "",
        dateEstablished: "",
        revenue: "",
        url: "",
        tin: "",

        amount: "",
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        cellPhone: "",
        validCode: "",
        streetAddress: "",
        // streetAddress2: "",
        cityName: "",
        title: "",
        jobTitle: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        dateOfBirth: "",
        homeOwnership: "",
        military: false,
        ssn: "",
        driverLicense: "",
        month: "",
        housingCost: "",
        businessOwnership: "",
        firstName2: "",
        middleName2: "",
        lastName2: "",
        email2: "",
        cellPhone2: "",
        streetAddress2: "",
        cityName2: "",
        title2: "",
        jobTitle2: "",
        zipCode2: "",
        state2: "",
        dateOfBirth2: "",
        homeOwnership2: "",
        month2: "",
        housingCost2: "",
        ssn2: "",
        status2: "",
        driverLicense2: "",
        businessOwnership2: "",

        vendorName: "",
        vendorPhone: "",
        vendorAddress: "",
        vendorCity: "",
        vendorState: "",
        vendorZipCode: "",
        vendorContactFirstName: "",
        vendorContactLastName: "",
        vendorContactEmail: "",
        equipmentDesc: "",
        equipmentAmount: "",
        equipmentStatus: "",
        term: "",
        equipmentTitle: "",
        equipmentType: "",
        stateOfInc: "",
        brokerNote: ""
      },
      rules: {
        tin: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("EIN can not be empty"));
              }else if (_.trim(value).length != 10 ) {
                callback(new Error("TIN must be 9 digital"));
              } 
              else {
                callback();
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      myInfo: types.GET_MY_INFO,
      userInfo: types.GET_USER,
      readDeclaration: types.GET_DECLARATION_IMAGE_SRC
    })
  },
  methods: {
    ...mapActions({
      updatePassword: types.UPDATE_PASSWORD,
      getPersonalInfo: types.GET_PERSONAL_INFO,
      getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
      savePersonalInfo: types.SAVE_PERSONAL_INFO,
      saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
      saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setAlertMessage: types.SET_FAIL_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),
    ...mapMutations({
      setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
      setFailModal: types.SET_FAIL_MESSAGE_STATE,
    }),

    reviewFile(fileId) {
      return window.open('mingdao/mobile/crmCustomerAttachInfoController/getFileById.ht?fileId=' + fileId, "_blank");
    },

    deleteFile(fileId) {
      api.deleteUploadedFile({
        token: this.userInfo.tokenId,
        id: fileId
      }).then((res) => {
        return this.getMgxyGetClientDetails();
      });
    },

    getMgxyGetPersonDetails() {
    },

    getData(val) {
      this.dateOfBirthStr = val;
    },
    getData2(val) {
      this.dateOfBirth2Str = val;
    },

    handleTinInput(value) {
      var newValue = value.replaceAll("-", "");
      if (newValue.length > 2) {
        this.brokerSubmitForm.tin = newValue.substr(0, 2) + "-" + newValue.substr(2);
      }
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureCardPreview2(file) {
      this.dialogImageUrl2 = file.url;
      this.dialogVisible2 = true;
    }, 
    handleAvatarSuccess(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      // this.fileUrl1 = 'mingdao/mobile/crmCustomerAttachInfoController/getFileById.ht?fileId=' + res.result.fileId;
      //var uploaded = document.getElementById("uploaded");
      //uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId;
      // this.bankStatement = res.result.fileId;
      // this.fileName1 = res.result.fileName;
      return this.getMgxyGetClientDetails();
    },
    // handleAvatarSuccess2(res, file) {
    //   Loading.service({ fullscreen: true, lock: true }).close();
    //   console.log(res.result);
    //   this.fileUrl2 = 'mingdao/mobile/crmCustomerAttachInfoController/getFileById.ht?fileId=' + res.result.fileId;
    //   // var uploaded = document.getElementById("uploaded2");
    //   // uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId;
    //   this.paymentStatement = res.result.fileId;
    //   this.fileName2 = res.result.fileName;
    // },
    async beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      return true;
    },

    submitUpload() {
      if(this.clientCustomerId && this.clientCustomerId != '') {
        this.$refs.upload.submit();
      } else {
        this.firstTimeUploadFileIndicator = 1;
        this.submitApplicationForm();
      }
    },

    openFullScreen() {
      Loading.service({ fullscreen: true, lock: true });
    },

    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age > 18;
    },
    
    getMgxyGetClientDetails() {
      var _this = this;
      //console.warn(this.userInfo)
      api.mgxyGetPersonDetails({
        token: _this.userInfo.token,
        frontApply: _this.frontApplyId,
        customerId: _this.clientCustomerId,
      }).then((res) => {
        var _data = res.data;
        if (_data.code == 0) {
          console.log(_data);
          _this.uploadedDocuments = _data.result.uploadedFileList;

          _this.brokerSubmitForm.jobTitle = _data.result.jobTitle || "";
          _this.brokerSubmitForm.firstName = _data.result.firstName;
          _this.brokerSubmitForm.middleName = _data.result.middleName;
          _this.brokerSubmitForm.lastName = _data.result.lastName;
          _this.brokerSubmitForm.email = _data.result.email;
          _this.brokerSubmitForm.cellPhone = _data.result.phone;
          _this.brokerSubmitForm.dateOfBirth = _data.result.dateOfBirth ? new Date(_data.result.dateOfBirth.replace(/-/g, "\/")) : "";
          // if (_data.result.dataOfBirth && _data.result.dataOfBirth != '') {
          //   this.dateOfBirthDis = true;
          // }
          _this.brokerSubmitForm.ssn = _data.result.ssn;
          _this.brokerSubmitForm.streetAddress = _data.result.streetAddress;
          _this.brokerSubmitForm.driverLicense = _data.result.driverLicense;
          // _this.brokerSubmitForm.housingCost = _data.result.housingCost;
          _this.brokerSubmitForm.state = _data.result.state;
          // _this.brokerSubmitForm.status = _data.result.status;
          _this.brokerSubmitForm.cityName = _data.result.cityName;
          _this.brokerSubmitForm.zipCode = _data.result.zipCode;
          // if(_data.result.month !== null && _data.result.month !== undefined && _data.result.month !== '') {
          //   _this.brokerSubmitForm.month = new Date(_data.result.month);
          // } 
          // _this.brokerSubmitForm.homeOwnership = _data.result.homeOwnership;
          _this.brokerSubmitForm.businessOwnership = _data.result.businessOwnership;
          
          _this.brokerSubmitForm.jobTitle2 = _data.result.jobTitle2 || "";
          _this.brokerSubmitForm.firstName2 = _data.result.firstName2 || "";
          _this.brokerSubmitForm.middleName2 = _data.result.middleName2 || "";
          _this.brokerSubmitForm.lastName2 = _data.result.lastName2 || "";
          _this.brokerSubmitForm.email2 = _data.result.email2 || "";
          _this.brokerSubmitForm.cellPhone2 = _data.result.phone2 || "";
          // _this.brokerSubmitForm.dateOfBirth2 = _data.result.dateOfBirth2 ? new Date(_data.result.dateOfBirth2.replace(/-/g, "\/")) : "";
          _this.brokerSubmitForm.ssn2 = _data.result.ssn2 || "";
          _this.brokerSubmitForm.streetAddress2 = _data.result.streetAddress2 || "";
          _this.brokerSubmitForm.driverLicense2 = _data.result.driverLicense2 || "";
          // _this.brokerSubmitForm.housingCost2 = _data.result.housingCost2;
          _this.brokerSubmitForm.state2 = _data.result.state2 || "";
          // _this.brokerSubmitForm.status2 = _data.result.status2;
          _this.brokerSubmitForm.cityName2 = _data.result.cityName2 || "";
          _this.brokerSubmitForm.zipCode2 = _data.result.zipCode2 || "";
          // if(_data.result.month2 !== null && _data.result.month2 !== undefined && _data.result.month2 !== '') {
          //   _this.brokerSubmitForm.month2 = new Date(_data.result.month2);
          // } 
          // _this.brokerSubmitForm.homeOwnership2 = _data.result.homeOwnership2;
          _this.brokerSubmitForm.businessOwnership2 = _data.result.businessOwnership2 || "";
          console.log(_this.brokerSubmitForm);
        }
      })
    },

    formatData(data) {
      var arr = [];
      for (var key in data) {
        var obj = {};
        obj.value = data[key];
        obj.text = key;
        arr.push(obj);
      }
      return arr;
    },
    formatDataForSort(data) {
      var arr = [];
      var arr2 = [];
      for (var key in data) {
        arr[arr.length] = data[key];
      }
      arr.sort();
      for (var k in arr) {
        for (key in data) {
          if (data[key] == arr[k]) {
            var obj = {};
            obj.value = data[key];
            obj.text = key;
            arr2.push(obj);
          }
        }
      }
      return arr2;
    },
    getMgxyDictionary() {
      var _this = this;
      api.mgxyDictionary().then(res => {
        _this.stateS = _this.formatData(res.data.result[0]);
        _this.titleData = _this.formatData(res.data.result[7]);
        _this.mastateS = _this.formatData(res.data.result[6]);
      });
    },

    brokerSubmitLoan() {
      var _this = this;
      var registerData = {
          firstName: _this.brokerSubmitForm.firstName,
          lastName: _this.brokerSubmitForm.lastName,
          middleName: _this.brokerSubmitForm.middleName,
          email: _this.brokerSubmitForm.email,
          brokerId: this.userInfo.crmCustomerId
      }
          
      api.brokerRegisterUser(registerData)
      .then(res => {
        this.isRegistering = false;
        if (Number(res.data.code) == 0) {

          var data = res.data.data;
          _this.clientCustomerId = data.crmCustomerId;

          if(this.firstTimeUploadFileIndicator === 1) {
            this.$refs.upload.submit();
            this.firstTimeUploadFileIndicator = 2;
          }
          
          api
            .mgxyBrokerApply({
              tokenId: _this.userInfo.token,
              clientCustomerId: _this.clientCustomerId,
              frontApplyProductId: 10000057823975,
              frontApplyMoney: _this.brokerSubmitForm.amount,
              frontApplyExpires: _this.brokerSubmitForm.term,
              frontApplyExpiresUnit: 2,
              frontInformationSources: '5'
            })
            .then(res => {
              console.log(res);
              var _data = res.data;
              if (_data.code == 0) {
                _this.frontApplyId = _data.result.frontApplyId;
                api.postForm("/mobile/item/loanItemFrontApply/mgxyUpdateApplyForFinish.ht",
                  {
                    tokenId: _this.userInfo.token,
                    frontApplyId: _this.frontApplyId
                  }
                ).then(res => {
                  _this.isLoading = false;
                  _this.saveBusinessOwner();
                });
              } else {
                this.setAlertMessage({
                  show: true,
                  content: _data.msg
                });
              }
            });
          return true;
        } else {
          if (res.data.result === "Failed to save, business owner email already exist") {
            alert(res.data.result);
          }
          return false;
        }
      });
    },
    submitApplicationForm() {
      var _this = this;
      this.$refs.brokerSubmitForm.validate(valid => {
        if (valid) {
          if (!this.getAge(this.dateOfBirthStr)) {
            this.$alert("Business owner must be more than 18 years old, please double check date of birth");
            return;
          }
          if(_this.frontApplyId === "") {
            _this.brokerSubmitLoan();
          } else {
            _this.saveBusinessOwner();
          }
        } else {
          this.$alert("Please input all required fields");
          if(this.firstTimeUploadFileIndicator === 1) {
            this.firstTimeUploadFileIndicator = 0;
            this.$refs.upload.clearFiles();
          }
          return;
        }
      });
    },

    saveBusinessOwner() {
      var _this = this;
      this.isLoading = true;
      var isValid = "";
      if (_this.isApplyFirst) {
        isValid = 2;
      } else {
        _this.SMSVerificationCode = "111111";
        isValid = 2;
      }

      var Month = new Array();
      Month[0] = "January";
      Month[1] = "February";
      Month[2] = "March";
      Month[3] = "April";
      Month[4] = "May";
      Month[5] = "June";
      Month[6] = "July";
      Month[7] = "August";
      Month[8] = "September";
      Month[9] = "October";
      Month[10] = "November";
      Month[11] = "December";

      var postData = {
        customerId: _this.clientCustomerId,
        tokenId: _this.userInfo.token,
        frontApplyId: _this.userInfo.crmCustomerId,
        lastName: _this.brokerSubmitForm.lastName,
        firstName: _this.brokerSubmitForm.firstName,
        middleName: _this.brokerSubmitForm.middleName,
        email: _this.brokerSubmitForm.email,
        phone: _this.brokerSubmitForm.cellPhone,
        validCode: _this.brokerSubmitForm.validCode,
        streetAddress: _this.brokerSubmitForm.streetAddress,
        cityName: _this.brokerSubmitForm.cityName,
        title: _this.brokerSubmitForm.title || "",
        jobTitle: _this.brokerSubmitForm.jobTitle,
        state: _this.brokerSubmitForm.state,
        ssn: _this.brokerSubmitForm.ssn,
        driverLicense: _this.brokerSubmitForm.driverLicense,
        zipCode: _this.brokerSubmitForm.zipCode,
        // status: _this.brokerSubmitForm.status,
        dateOfBirth: _this.dateOfBirthStr,
        isValid: 1,
        // homeOwnership: _this.brokerSubmitForm.homeOwnership,
        customer_area: _this.brokerSubmitForm.military ? "Military" : "",
        military: _this.brokerSubmitForm.military,
        // month: _this.brokerSubmitForm.month == "" ? "" : _this.brokerSubmitForm.month.toISOString(),
        // housingCost: _this.brokerSubmitForm.housingCost,
        businessOwnership: _this.brokerSubmitForm.businessOwnership,
        lastName2: _this.brokerSubmitForm.lastName2,
        firstName2: _this.brokerSubmitForm.firstName2,
        middleName2: _this.brokerSubmitForm.middleName2,
        email2: _this.brokerSubmitForm.email2,
        phone2: _this.brokerSubmitForm.cellPhone2,
        streetAddress2: _this.brokerSubmitForm.streetAddress2,
        cityName2: _this.brokerSubmitForm.cityName2,
        jobTitle2: _this.brokerSubmitForm.jobTitle2,
        state2: _this.brokerSubmitForm.state2,
        ssn2: _this.brokerSubmitForm.ssn2,
        driverLicense2: _this.brokerSubmitForm.driverLicense2,
        zipCode2: _this.brokerSubmitForm.zipCode2,
        // status2: _this.brokerSubmitForm.status2,
        // dateOfBirth2: _this.dateOfBirth2Str,
        // homeOwnership2: _this.brokerSubmitForm.homeOwnership2,
        // month2: _this.brokerSubmitForm.month2 == "" ? "" : _this.brokerSubmitForm.month2.toISOString(),
        // housingCost2: _this.brokerSubmitForm.housingCost2,
        businessOwnership2: _this.brokerSubmitForm.businessOwnership2
      };

      console.log('postData', postData);

      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyBrokerUpdateApplyForPersonDetails.ht",
          postData 
        )
        .then(res => {
          console.log(res);
          var _data = res.data;
          this.isLoading = false;
          if (_data.code == 0) {
            // this.setAlertMessage({
            //   show: true,
            //   content: "Success to save personal information"
            // });
            console.log("Success to save personal information");
            _this.submitBusinessInfo();
          } else {
            this.setAlertMessage({
              show: true,
              content: _data.msg
            });
          }
        });
    },

    submitBusinessInfo() {
      var _this = this;
      this.isLoading = true;
      api.postForm("/mobile/item/loanItemFrontApply/updateSBL01.ht", {
        tokenId: _this.userInfo.token,
        customerId: _this.clientCustomerId,
        frontApplyId: _this.frontApplyId,
        
        name: _this.brokerSubmitForm.businessName,
        tradeName: _this.brokerSubmitForm.tradeName,
        street: _this.brokerSubmitForm.businessStreetAddress,
        city: _this.brokerSubmitForm.businessCityName,
        state: _this.brokerSubmitForm.businessState,
        zipCode: _this.brokerSubmitForm.zipCode,
        phone: _this.brokerSubmitForm.phone,
        tin: _this.brokerSubmitForm.tin,
        fax: _this.brokerSubmitForm.fax,
        industry: _this.brokerSubmitForm.industry,
        structure: _this.brokerSubmitForm.structure,
        dateEstablished: typeof _this.brokerSubmitForm.dateEstablished === 'string' ? _this.brokerSubmitForm.dateEstablished : _this.brokerSubmitForm.dateEstablished.toISOString(),
        revenue: _this.brokerSubmitForm.revenue,
        website: _this.brokerSubmitForm.url,
        businessDesc: _this.brokerSubmitForm.description,
        companyEmail: _this.brokerSubmitForm.companyEmail,
        stateOfIncorporation: _this.brokerSubmitForm.stateOfInc
      }).then(res => {
        //             alert(res.date.code);
        //             alert(res.date.msg);
        var _data = res.data;
        this.isLoading = false;
        if (_data.code == 0) {
          console.log(res);
          // this.setAlertMessage({
          //   show: true,
          //   content: "Success to save business information"
          // });
          console.log("Success to save business information");
          _this.submitVendorForm();
        } else {
          this.setAlertMessage({
            show: true,
            content: _data.msg
          });
        }
      });
    },

    submitVendorForm() {
      var vendorData = {
        tokenId: this.userInfo.token,
        customerId: this.clientCustomerId,
        frontApplyId: this.frontApplyId,

        vendorName: this.brokerSubmitForm.vendorName,
        vendorPhone: this.brokerSubmitForm.vendorPhone,
        vendorAddress: this.brokerSubmitForm.vendorAddress,
        vendorCity: this.brokerSubmitForm.vendorCity,
        vendorState: this.brokerSubmitForm.vendorState,
        vendorZipCode: this.brokerSubmitForm.vendorZipCode,
        equipmentAmount: this.brokerSubmitForm.equipmentAmount,
        vendorContactFirstName: this.brokerSubmitForm.vendorContactFirstName,
        vendorContactLastName: this.brokerSubmitForm.vendorContactLastName,
        vendorContactEmail: this.brokerSubmitForm.vendorContactEmail,
        equipmentTitle: this.brokerSubmitForm.equipmentTitle,
        equipmentType: this.brokerSubmitForm.equipmentType,
        brokerNote: this.brokerSubmitForm.brokerNote,
        equipmentStatus: this.brokerSubmitForm.equipmentStatus,
        equipmentDesc: this.brokerSubmitForm.equipmentDesc,
        bankStatement: this.bankStatement || "",
        paymentStatement: this.paymentStatement || ""
      }
      // if(this.brokerSubmitForm.equipmentAmount) {
      //   vendorData.equipmentAmount = this.brokerSubmitForm.equipmentAmount;
      // }

      api.postForm("/mobile/item/loanItemFrontApply/updateUpload.ht", vendorData)
        .then(res => {
          console.log(res);
          console.log("Success to save vendor information");

          if(this.firstTimeUploadFileIndicator === 2) {
            this.firstTimeUploadFileIndicator = -1;
          } else {
            this.setSuccessMessage({
              show: true,
              content: "Success to submit application"
            });
            this.$router.push({path: `/brokerCenter/applicationDetail/${this.frontApplyId}`});
          }
        });
    },

    handleDialogClose(done) {
      if(this.declarationId == null || this.declarationId == 10000058500118) {
        this.showSignDeclarationWarning = true;
      } else {
        done();
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.path.indexOf("register") !== -1) {
      next(false);
    } else {
      next();
    }
  },

  mounted() {
    console.log(this.frontApplyId);
    this.getMgxyDictionary();
    this.getPersonalInitData({
      token: this.userInfo.token,
      customerId: this.userInfo.crmCustomerId
    }).then(res => {
      console.log(res);
      if (Number(res.data.code) === 0) {
        const data = res.data.result;
        console.log(data);
      }
    });
  }
};
</script>

<style lang="scss">
.el-input.is-disabled .el-input__inner {
  background: #f7f7f7;
}

.step1-form .step-form__title {
  padding-bottom: 120px;
}

.step-form__form .el-form-item {
    margin-bottom: 25px !important;
}

.step-form__form .el-form-item__error {
    padding-top: 5px !important;
}

.el-table__body-wrapper td .cell {
  padding-left: 18px !important;
}

.el-input-group__append, 
.el-input-group__prepend, 
.step-form__form .el-textarea .el-textarea__inner,
.step-form__form .el-input .el-input__inner {
  border-color: #606060 !important;
  border-radius: 0 !important;
}

</style>



// WEBPACK FOOTER //
// NewApplication.vue?02a42c1f